import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0953137f")

_pushScopeId("data-v-0953137f")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-m-4" }
const _hoisted_3 = { class: "p-float-label " }
const _hoisted_4 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-d-flex p-flex-row p-jc-end" }
const _hoisted_6 = { class: "input-help p-m-0" }
const _hoisted_7 = { class: "p-m-4" }
const _hoisted_8 = { class: "p-float-label " }
const _hoisted_9 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_10 = { class: "p-d-flex p-flex-row p-jc-end" }
const _hoisted_11 = { class: "input-help p-m-0" }
const _hoisted_12 = { class: "p-m-4" }
const _hoisted_13 = { class: "p-float-label p-mb-2" }
const _hoisted_14 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_15 = { class: "p-d-flex p-flex-row p-jc-end" }
const _hoisted_16 = { class: "input-help p-m-0" }
const _hoisted_17 = { class: "p-d-flex p-flex-row p-jc-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.workspaceDataCloneDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('workspace.myData.clonedDatasetWizard')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_17, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.closeDialog
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.cloneDataset,
          disabled: _ctx.buttonDisabled
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    default: _withId(() => [
      (_ctx.dataset)
        ? (_openBlock(), _createBlock("form", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", _hoisted_3, [
                _createVNode(_component_InputText, {
                  id: "label",
                  class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.dataset.label.$invalid && _ctx.v$.dataset.label.$dirty
                        }],
                  maxLength: _ctx.workspaceDataCloneDialogDescriptor.labelMaxLength,
                  modelValue: _ctx.v$.dataset.label.$model,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.dataset.label.$model = $event)),
                  modelModifiers: { trim: true },
                  onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.dataset.label.$touch()))
                }, null, 8, ["maxLength", "modelValue", "class"]),
                _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.label')) + " * ", 1)
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.dataset.label,
                  additionalTranslateParams: {
                            fieldName: _ctx.$t('common.label')
                        }
                }, null, 8, ["vComp", "additionalTranslateParams"]),
                _createVNode("p", _hoisted_6, _toDisplayString(_ctx.labelHelp), 1)
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("span", _hoisted_8, [
                _createVNode(_component_InputText, {
                  id: "name",
                  class: ["kn-material-input", {
                            'p-invalid': _ctx.v$.dataset.name.$invalid && _ctx.v$.dataset.name.$dirty
                        }],
                  maxLength: _ctx.workspaceDataCloneDialogDescriptor.nameMaxLength,
                  modelValue: _ctx.v$.dataset.name.$model,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.dataset.name.$model = $event)),
                  modelModifiers: { trim: true },
                  onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.dataset.name.$touch()))
                }, null, 8, ["maxLength", "modelValue", "class"]),
                _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.dataset.name,
                  additionalTranslateParams: {
                            fieldName: _ctx.$t('common.name')
                        }
                }, null, 8, ["vComp", "additionalTranslateParams"]),
                _createVNode("p", _hoisted_11, _toDisplayString(_ctx.nameHelp), 1)
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("span", _hoisted_13, [
                _createVNode(_component_InputText, {
                  id: "description",
                  class: "kn-material-input",
                  maxLength: _ctx.workspaceDataCloneDialogDescriptor.descriptionMaxLength,
                  modelValue: _ctx.dataset.description,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dataset.description = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["maxLength", "modelValue"]),
                _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('common.description')), 1)
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode("p", _hoisted_16, _toDisplayString(_ctx.descriptionHelp), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
})